var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLuucy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 127.55 28.54",
    style: {
      enableBackground: "new 0 0 127.55 28.54"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 14.26,
    cy: 14.27,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.26,
    cy: 23.61,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.26,
    cy: 19.07,
    r: 1.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.26,
    cy: 27.88,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.59,
    cy: 14.27,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.05,
    cy: 19.07,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.05,
    cy: 14.27,
    r: 1.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.59,
    cy: 19.07,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.05,
    cy: 23.61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.86,
    cy: 14.27,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.86,
    cy: 19.07,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.59,
    cy: 23.61,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.05,
    cy: 27.88,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.26,
    cy: 4.94,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.05,
    cy: 9.48,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.26,
    cy: 9.48,
    r: 1.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.05,
    cy: 4.94,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.59,
    cy: 9.48,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.26,
    cy: 0.67,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.05,
    cy: 0.67,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.59,
    cy: 4.94,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.86,
    cy: 9.48,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.94,
    cy: 14.27,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.47,
    cy: 9.48,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.47,
    cy: 14.27,
    r: 1.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.94,
    cy: 9.48,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.47,
    cy: 4.94,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.67,
    cy: 14.27,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.67,
    cy: 9.48,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.94,
    cy: 4.94,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.47,
    cy: 0.67,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.47,
    cy: 19.07,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.47,
    cy: 23.61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.94,
    cy: 19.07,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.47,
    cy: 27.88,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.94,
    cy: 23.61,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.67,
    cy: 19.07,
    r: 0.67
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.94,5.33h3.89v14.51h8.42v3.63h-12.3V5.33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.87,23.85c-1.18,0-2.25-0.19-3.21-0.58c-0.97-0.39-1.8-0.93-2.49-1.62c-0.69-0.69-1.23-1.52-1.62-2.49    c-0.39-0.97-0.58-2.04-0.58-3.21V5.33h3.89v10.62c0,0.66,0.1,1.24,0.3,1.76c0.2,0.52,0.47,0.97,0.83,1.35    c0.35,0.38,0.78,0.67,1.27,0.87c0.49,0.2,1.03,0.3,1.62,0.3c0.59,0,1.13-0.1,1.62-0.3c0.49-0.2,0.92-0.49,1.27-0.87    c0.35-0.38,0.63-0.83,0.83-1.35c0.2-0.52,0.3-1.11,0.3-1.76V5.33h3.89v10.62c0,1.17-0.19,2.24-0.58,3.21    c-0.39,0.97-0.93,1.8-1.62,2.49c-0.69,0.69-1.52,1.23-2.5,1.62C60.09,23.66,59.02,23.85,57.87,23.85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.11,23.85c-1.18,0-2.25-0.19-3.21-0.58c-0.97-0.39-1.8-0.93-2.49-1.62c-0.69-0.69-1.23-1.52-1.62-2.49    c-0.39-0.97-0.58-2.04-0.58-3.21V5.33h3.89v10.62c0,0.66,0.1,1.24,0.3,1.76c0.2,0.52,0.47,0.97,0.83,1.35    c0.35,0.38,0.78,0.67,1.27,0.87c0.49,0.2,1.03,0.3,1.62,0.3c0.59,0,1.13-0.1,1.62-0.3c0.49-0.2,0.92-0.49,1.27-0.87    c0.35-0.38,0.63-0.83,0.83-1.35c0.2-0.52,0.3-1.11,0.3-1.76V5.33h3.89v10.62c0,1.17-0.19,2.24-0.58,3.21    c-0.39,0.97-0.93,1.8-1.62,2.49c-0.69,0.69-1.52,1.23-2.5,1.62C81.33,23.66,80.27,23.85,79.11,23.85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.26,23.85c-1.4,0-2.7-0.25-3.9-0.75c-1.2-0.5-2.24-1.18-3.12-2.03c-0.88-0.85-1.57-1.86-2.07-3    c-0.5-1.15-0.75-2.37-0.75-3.67c0-1.29,0.25-2.52,0.75-3.67c0.5-1.15,1.19-2.15,2.07-3c0.88-0.85,1.92-1.53,3.12-2.03    c1.2-0.5,2.5-0.75,3.9-0.75c1.26,0,2.37,0.19,3.33,0.57c0.96,0.38,1.76,0.79,2.4,1.24c0.74,0.54,1.38,1.14,1.92,1.81l-2.59,2.59    c-0.38-0.48-0.82-0.92-1.32-1.29c-0.43-0.33-0.96-0.63-1.58-0.89c-0.62-0.27-1.34-0.4-2.15-0.4s-1.57,0.15-2.28,0.45    c-0.71,0.3-1.33,0.72-1.85,1.24c-0.53,0.53-0.94,1.14-1.24,1.85c-0.3,0.71-0.45,1.47-0.45,2.28c0,0.81,0.15,1.57,0.45,2.28    c0.3,0.71,0.72,1.32,1.24,1.85c0.53,0.53,1.14,0.94,1.85,1.24c0.71,0.3,1.47,0.45,2.28,0.45c0.85,0,1.59-0.13,2.23-0.4    c0.64-0.27,1.18-0.57,1.63-0.89c0.52-0.38,0.96-0.81,1.32-1.3l2.59,2.59c-0.54,0.67-1.18,1.28-1.94,1.81    c-0.66,0.45-1.47,0.86-2.43,1.24C103.68,23.66,102.55,23.85,101.26,23.85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.8,16.99l-6.86-11.66h4.53l4.22,7.77h0.1l4.22-7.77h4.53l-6.86,11.66v6.48h-3.89V16.99z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLuucy);
export default __webpack_public_path__ + "static/media/logo_luucy.4c417bc418f9c8593408cca9e9b1d0b1.svg";
export { ForwardRef as ReactComponent };